import { jsx as _jsx } from "react/jsx-runtime";
import { Folder, Timer, TravelExplore } from "@mui/icons-material";
import { EmptyState } from "../../shared/EmptyState";
export const PriorityEntryEmptyState = ({ onAddPriorityEntry }) => {
    return (_jsx(EmptyState, { backgroundIcon: Folder, primaryIcon: TravelExplore, accentIcon: Timer, title: "Pipeline is Empty", description: "When clients are added to your pipeline, they will appear here. This is where you'll manage and track client appointments and scheduling.", action: onAddPriorityEntry
            ? { label: "Add Client", onClick: onAddPriorityEntry }
            : undefined }));
};
